export default "__VITE_ASSET__21837c37__"